import { useLingui } from '@lingui/react/macro';
import { createFileRoute } from '@tanstack/react-router';

import { FormPage } from '@/components/page/FormPage';
import { ProfileForm } from '@/features/users/components/ProfileForm';
import { useUser } from '@/hooks';
import { trpc } from '@/services/trpc';
import { useBoundStore } from '@/store/store';

export const Route = createFileRoute('/_baseLayout/users/profile/')({
  component: ProfilePage,
  loader: async ({ context: { trpcUtils } }) =>
    trpcUtils.users.findOne.ensureData({
      id: useBoundStore.getState().user!.id,
    }),
});

export function ProfilePage() {
  const { t } = useLingui();
  const { user } = useUser();
  const [data] = trpc.users.findOne.useSuspenseQuery({ id: user!.id });

  return (
    <FormPage
      title={`${t`Profile`}`}
      breadcrumbs={[
        {
          label: t`Profile`,
          to: '/users/profile',
        },
      ]}
    >
      <ProfileForm data={data} />
    </FormPage>
  );
}
